// ========================================
// 📋 TYPES D'ACTIONS USER
// ========================================

export const UPDATE_USER = 'UPDATE_USER';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';

export const GET_ALL_USERS_REQUEST = 'GET_ALL_USERS_REQUEST';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAIL = 'GET_ALL_USERS_FAIL';

export const GET_USERS_BY_STATUS_REQUEST = 'GET_USERS_BY_STATUS_REQUEST';
export const GET_USERS_BY_STATUS_SUCCESS = 'GET_USERS_BY_STATUS_SUCCESS';
export const GET_USERS_BY_STATUS_FAIL = 'GET_USERS_BY_STATUS_FAIL';

export const GET_USERS_BY_JOB_REQUEST = 'GET_USERS_BY_JOB_REQUEST';
export const GET_USERS_BY_JOB_SUCCESS = 'GET_USERS_BY_JOB_SUCCESS';
export const GET_USERS_BY_JOB_FAIL = 'GET_USERS_BY_JOB_FAIL';

export const GET_USERS_BY_ENTITY_REQUEST = 'GET_USERS_BY_ENTITY_REQUEST';
export const GET_USERS_BY_ENTITY_SUCCESS = 'GET_USERS_BY_ENTITY_SUCCESS';
export const GET_USERS_BY_ENTITY_FAIL = 'GET_USERS_BY_ENTITY_FAIL';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const ASSIGN_ROLES_REQUEST = 'ASSIGN_ROLES_REQUEST';
export const ASSIGN_ROLES_SUCCESS = 'ASSIGN_ROLES_SUCCESS';
export const ASSIGN_ROLES_FAIL = 'ASSIGN_ROLES_FAIL';

export const REMOVE_ROLES_REQUEST = 'REMOVE_ROLES_REQUEST';
export const REMOVE_ROLES_SUCCESS = 'REMOVE_ROLES_SUCCESS';
export const REMOVE_ROLES_FAIL = 'REMOVE_ROLES_FAIL';

export const SET_LOADING = 'SET_LOADING';
export const DOWNLOAD_USERS_TEMPLATE = 'DOWNLOAD_USERS_TEMPLATE';

export const EXPORT_USERS_REQUEST = 'EXPORT_USERS_REQUEST';
export const EXPORT_USERS_SUCCESS = 'EXPORT_USERS_SUCCESS';
export const EXPORT_USERS_FAIL    = 'EXPORT_USERS_FAIL';

// ========================================
// 🚚 MASS IMPORT USERS
// ========================================
export const MASS_IMPORT_USERS_REQUEST = "MASS_IMPORT_USERS_REQUEST";
export const MASS_IMPORT_USERS_SUCCESS = "MASS_IMPORT_USERS_SUCCESS";
export const MASS_IMPORT_USERS_FAIL = "MASS_IMPORT_USERS_FAIL";

// 📥 DOWNLOAD USERS TEMPLATE
// ========================================
export const DOWNLOAD_USERS_TEMPLATE_REQUEST = "DOWNLOAD_USERS_TEMPLATE_REQUEST";
export const DOWNLOAD_USERS_TEMPLATE_SUCCESS = "DOWNLOAD_USERS_TEMPLATE_SUCCESS";
export const DOWNLOAD_USERS_TEMPLATE_FAIL = "DOWNLOAD_USERS_TEMPLATE_FAIL";


export const REVIEW_USERS_MASS_IMPORT_REQUEST = "REVIEW_USERS_MASS_IMPORT_REQUEST";
export const REVIEW_USERS_MASS_IMPORT_SUCCESS = "REVIEW_USERS_MASS_IMPORT_SUCCESS";
export const REVIEW_USERS_MASS_IMPORT_FAIL = "REVIEW_USERS_MASS_IMPORT_FAIL";

export const IMPORT_USERS_MASS_REQUEST = "IMPORT_USERS_MASS_REQUEST";
export const IMPORT_USERS_MASS_SUCCESS = "IMPORT_USERS_MASS_SUCCESS";
export const IMPORT_USERS_MASS_FAIL = "IMPORT_USERS_MASS_FAIL";


export const GET_TROMBINOSCOPE_REQUEST = "GET_TROMBINOSCOPE_REQUEST";
export const GET_TROMBINOSCOPE_SUCCESS = "GET_TROMBINOSCOPE_SUCCESS";
export const GET_TROMBINOSCOPE_FAILURE = "GET_TROMBINOSCOPE_FAILURE";

export const GET_USER_JOB_HISTORY_REQUEST = "GET_USER_JOB_HISTORY_REQUEST";
export const GET_USER_JOB_HISTORY_SUCCESS = "GET_USER_JOB_HISTORY_SUCCESS";
export const GET_USER_JOB_HISTORY_FAILURE = "GET_USER_JOB_HISTORY_FAILURE";
export const CLEAR_USER_JOB_HISTORY = "CLEAR_USER_JOB_HISTORY";

export const GET_DIRECT_REPORTS_REQUEST = 'GET_DIRECT_REPORTS_REQUEST';
export const GET_DIRECT_REPORTS_SUCCESS = 'GET_DIRECT_REPORTS_SUCCESS';
export const GET_DIRECT_REPORTS_FAIL = 'GET_DIRECT_REPORTS_FAIL';

export const UPDATE_MY_PROFILE_REQUEST = 'UPDATE_MY_PROFILE_REQUEST';
export const UPDATE_MY_PROFILE_SUCCESS = 'UPDATE_MY_PROFILE_SUCCESS';
export const UPDATE_MY_PROFILE_FAIL    = 'UPDATE_MY_PROFILE_FAIL';

export const UPLOAD_USER_PHOTO_REQUEST = 'UPLOAD_USER_PHOTO_REQUEST';
export const UPLOAD_USER_PHOTO_SUCCESS = 'UPLOAD_USER_PHOTO_SUCCESS';
export const UPLOAD_USER_PHOTO_FAIL    = 'UPLOAD_USER_PHOTO_FAIL';

export const UPLOAD_ATTESTATION_RIB_REQUEST = 'UPLOAD_ATTESTATION_RIB_REQUEST';
export const UPLOAD_ATTESTATION_RIB_SUCCESS = 'UPLOAD_ATTESTATION_RIB_SUCCESS';
export const UPLOAD_ATTESTATION_RIB_FAIL    = 'UPLOAD_ATTESTATION_RIB_FAIL';


// Action creators
export const getDirectReportsRequest = (managerId) => ({
    type: GET_DIRECT_REPORTS_REQUEST,
    payload: { managerId }
});

export const getDirectReportsSuccess = (reports) => ({
    type: GET_DIRECT_REPORTS_SUCCESS,
    payload: reports
});

export const getDirectReportsFail = (error) => ({
    type: GET_DIRECT_REPORTS_FAIL,
    error
});


// ========================================
// 🎬 ACTION CREATORS
// ========================================

// ========================================
export const updateMyProfileRequest = (userId, data)            => ({ type: UPDATE_MY_PROFILE_REQUEST, payload: { userId, data } });
export const updateMyProfileSuccess = (user)                    => ({ type: UPDATE_MY_PROFILE_SUCCESS, payload: user });
export const updateMyProfileFail    = (error)                   => ({ type: UPDATE_MY_PROFILE_FAIL,    payload: error });

export const uploadUserPhotoRequest = (userId, file, photoType) => ({ type: UPLOAD_USER_PHOTO_REQUEST, payload: { userId, file, photoType } });
export const uploadUserPhotoSuccess = (user)                    => ({ type: UPLOAD_USER_PHOTO_SUCCESS, payload: user });
export const uploadUserPhotoFail    = (error)                   => ({ type: UPLOAD_USER_PHOTO_FAIL,    payload: error });

export const uploadAttestationRibRequest = (userId, file) => ({ type: UPLOAD_ATTESTATION_RIB_REQUEST, payload: { userId, file } });
export const uploadAttestationRibSuccess = (user)         => ({ type: UPLOAD_ATTESTATION_RIB_SUCCESS, payload: user });
export const uploadAttestationRibFail    = (error)        => ({ type: UPLOAD_ATTESTATION_RIB_FAIL,    payload: error });


export const getUserJobHistoryRequest = (userId) => ({
    type: GET_USER_JOB_HISTORY_REQUEST,
    payload: { userId },
});

export const getUserJobHistorySuccess = (userId, data) => ({
    type: GET_USER_JOB_HISTORY_SUCCESS,
    payload: { userId, data },
});

export const getUserJobHistoryFailure = (userId, error) => ({
    type: GET_USER_JOB_HISTORY_FAILURE,
    payload: { userId, error },
});

export const clearUserJobHistory = () => ({
    type: CLEAR_USER_JOB_HISTORY,
});

export const getTrombinoscopeRequest = () => ({ type: GET_TROMBINOSCOPE_REQUEST });
export const getTrombinoscopeSuccess = (data) => ({ type: GET_TROMBINOSCOPE_SUCCESS, payload: data });
export const getTrombinoscopeFailure = (err) => ({ type: GET_TROMBINOSCOPE_FAILURE, payload: err });

export const reviewUsersMassImportRequest = (companyId, action, rows) => ({
    type: REVIEW_USERS_MASS_IMPORT_REQUEST,
    payload: { companyId, action, rows },
});

export const reviewUsersMassImportSuccess = (result) => ({
    type: REVIEW_USERS_MASS_IMPORT_SUCCESS,
    payload: result, // { errors, warnings, totalRows, validRows }
});

export const reviewUsersMassImportFail = (error) => ({
    type: REVIEW_USERS_MASS_IMPORT_FAIL,
    error,
});

export const importUsersMassRequest = (companyId, action, rows) => ({
    type: IMPORT_USERS_MASS_REQUEST,
    payload: { companyId, action, rows },
});

export const importUsersMassSuccess = (users) => ({
    type: IMPORT_USERS_MASS_SUCCESS,
    payload: users,
});

export const importUsersMassFail = (error) => ({
    type: IMPORT_USERS_MASS_FAIL,
    error,
});

export const downloadUsersTemplateRequest = () => ({
    type: DOWNLOAD_USERS_TEMPLATE_REQUEST,
});

export const exportUsersRequest = () => ({
    type: EXPORT_USERS_REQUEST,
});

export const downloadUsersTemplateSuccess = () => ({
    type: DOWNLOAD_USERS_TEMPLATE_SUCCESS,
});

export const downloadUsersTemplateFail = (error) => ({
    type: DOWNLOAD_USERS_TEMPLATE_FAIL,
    error,
});


export const massImportUsersRequest = (companyId, action, users, history) => ({
    type: MASS_IMPORT_USERS_REQUEST,
    payload: { companyId, action, users },
    history,
});

export const massImportUsersSuccess = (users) => ({
    type: MASS_IMPORT_USERS_SUCCESS,
    payload: users,
});

export const massImportUsersFail = (error) => ({
    type: MASS_IMPORT_USERS_FAIL,
    error,
});


export const updateUser = (user) => {
    return {
        type: UPDATE_USER,
        payload: user  // ✅ Ou juste user directement
    };
}


// --- Récupérer un utilisateur par ID ---
export const getUserRequest = (userId) => ({
    type: GET_USER_REQUEST,
    payload: { userId }
});

export const getUserSuccess = (user) => ({
    type: GET_USER_SUCCESS,
    payload: user
});

export const getUserFail = (error) => ({
    type: GET_USER_FAIL,
    error
});

// --- Récupérer tous les utilisateurs ---
export const getAllUsersRequest = () => ({
    type: GET_ALL_USERS_REQUEST
});

export const getAllUsersSuccess = (users) => ({
    type: GET_ALL_USERS_SUCCESS,
    payload: users
});

export const getAllUsersFail = (error) => ({
    type: GET_ALL_USERS_FAIL,
    error
});

// --- Récupérer utilisateurs par statut ---
export const getUsersByStatusRequest = (status) => ({
    type: GET_USERS_BY_STATUS_REQUEST,
    payload: { status }
});

export const getUsersByStatusSuccess = (users) => ({
    type: GET_USERS_BY_STATUS_SUCCESS,
    payload: users
});

export const getUsersByStatusFail = (error) => ({
    type: GET_USERS_BY_STATUS_FAIL,
    error
});

// --- Récupérer utilisateurs par job ---
export const getUsersByJobRequest = (jobId) => ({
    type: GET_USERS_BY_JOB_REQUEST,
    payload: { jobId }
});

export const getUsersByJobSuccess = (users) => ({
    type: GET_USERS_BY_JOB_SUCCESS,
    payload: users
});

export const getUsersByJobFail = (error) => ({
    type: GET_USERS_BY_JOB_FAIL,
    error
});

// --- Récupérer utilisateurs par entité ---
export const getUsersByEntityRequest = (entityId) => ({
    type: GET_USERS_BY_ENTITY_REQUEST,
    payload: { entityId }
});

export const getUsersByEntitySuccess = (users) => ({
    type: GET_USERS_BY_ENTITY_SUCCESS,
    payload: users
});

export const getUsersByEntityFail = (error) => ({
    type: GET_USERS_BY_ENTITY_FAIL,
    error
});

// --- Créer un utilisateur ---
export const createUserRequest = (userData, history) => ({
    type: CREATE_USER_REQUEST,
    payload: userData,
    history
});

export const createUserSuccess = (user) => ({
    type: CREATE_USER_SUCCESS,
    payload: user
});

export const createUserFail = (error) => ({
    type: CREATE_USER_FAIL,
    error
});

// --- Mettre à jour un utilisateur ---
export const updateUserRequest = (userId, userData) => ({
    type: UPDATE_USER_REQUEST,
    payload: { userId, userData }
});

export const updateUserSuccess = (user) => ({
    type: UPDATE_USER_SUCCESS,
    payload: user
});

export const updateUserFail = (error) => ({
    type: UPDATE_USER_FAIL,
    error
});

// --- Supprimer un utilisateur ---
export const deleteUserRequest = (userId, history) => ({
    type: DELETE_USER_REQUEST,
    payload: { userId },
    history
});

export const deleteUserSuccess = (userId) => ({
    type: DELETE_USER_SUCCESS,
    payload: { userId }
});

export const deleteUserFail = (error) => ({
    type: DELETE_USER_FAIL,
    error
});

// --- Assigner des rôles ---
export const assignRolesRequest = (userId, roleIds) => ({
    type: ASSIGN_ROLES_REQUEST,
    payload: { userId, roleIds }
});

export const assignRolesSuccess = (data) => ({
    type: ASSIGN_ROLES_SUCCESS,
    payload: data
});

export const assignRolesFail = (error) => ({
    type: ASSIGN_ROLES_FAIL,
    error
});

// --- Retirer des rôles ---
export const removeRolesRequest = (userId, roleIds) => ({
    type: REMOVE_ROLES_REQUEST,
    payload: { userId, roleIds }
});

export const removeRolesSuccess = () => ({
    type: REMOVE_ROLES_SUCCESS
});

export const removeRolesFail = (error) => ({
    type: REMOVE_ROLES_FAIL,
    error
});

// --- Loading ---
export const setLoading = (loading) => ({
    type: SET_LOADING,
    payload: loading
});
